import { ICTAAttributes } from 'app/helpers/CTAInspectorPanels'

export const registerBlockCTAAttributes = {
  cta1Text: { type: 'text' },
  cta1Url: { type: 'text' },
  cta1Target: { type: 'text' },
  cta1Rel: { type: 'text' },
  cta1ClassName: { type: 'text', default: '' },
  cta2Text: { type: 'text' },
  cta2Url: { type: 'text' },
  cta2Target: { type: 'text' },
  cta2Rel: { type: 'text' },
  cta2ClassName: { type: 'text', default: '' },
}

const defaultAttributes = {
  cta1Text: '',
  cta1Url: '',
  cta1Target: '',
  cta1Rel: '',
  cta1ClassName: '',
  cta2Text: '',
  cta2Url: '',
  cta2Target: '',
  cta2Rel: '',
  cta2ClassName: '',
}

export const useCTAAttributes = (attrs: ICTAAttributes) => {
  const attributes = { ...defaultAttributes, ...attrs }

  const callToAction = attributes.cta1Text
    ? {
        text: attributes.cta1Text,
        url: attributes.cta1Url,
        target: attributes.cta1Target,
        rel: attributes.cta1Rel,
        className: attributes.cta1ClassName ?? '',
      }
    : undefined

  const secondaryCallToAction = attributes.cta2Text
    ? {
        text: attributes.cta2Text,
        url: attributes.cta2Url,
        target: attributes.cta2Target,
        rel: attributes.cta2Rel,
        className: attributes.cta2ClassName ?? '',
      }
    : undefined

  return { callToAction, secondaryCallToAction }
}
